function importAll(itemsList) {
  return itemsList.keys().map(itemsList);
}

export default importAll;
